export default {"src":"https://fishbrain.com/_next/static/media/snook.557e9ad0.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};